import React, { forwardRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useClasses from '../../hooks/useClasses';
import { addRootClasses, removeRootClasses } from '../../store/actions/UI';
import './style.scss';

export type DropdownProps = Omit<
React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
'ref'
> & {
  isOpen?: boolean
};

const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({
    children, isOpen, className, ...props
  }, ref) => {
    const { buildClass, joinClasses } = useClasses('Dropdown', {
      open: isOpen,
    });
    const dispatch = useDispatch();

    useEffect(() => {
      if (isOpen) {
        dispatch(addRootClasses('menu-open'));
        dispatch(removeRootClasses('menu-closed'));
      } else {
        dispatch(addRootClasses('menu-closed'));
        dispatch(removeRootClasses('menu-open'));
      }
    }, [isOpen, dispatch]);

    return (
      <div
        className={joinClasses(buildClass(), className)}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    );
  },
);

export default Dropdown;
